
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import JQuery from 'jquery';
    import { Wait } from '@/__env/ext';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import detalles from './detalles.vue';
    import lista from './lista.vue';
    import mini from './lista-mini.vue';
    import inicio from './lista-inicio.vue';
    import * as Pedidos from '@lib/Ventas/Pedidos';




    @Component( {
        name: "Componente",
        props: {},
        components: {
            detalles,
            lista,
            mini,
            inicio,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        public ExpandirDetalles: boolean = false;
        public Estado: 'cargando' | 'ok' | 'vacio' = 'ok';
        public Focused: boolean = false;
        public InputError: boolean = false;
        public InputErrorTimer: boolean = false;
        async onInputError()
        {
            this.InputError = true;
            this.InputErrorTimer = true;
            await Wait( 200 );
            this.InputErrorTimer = false;
            await Wait( 200 );
            this.InputErrorTimer = true;
            await Wait( 200 );
            this.InputErrorTimer = false;
            await Wait( 200 );
            this.InputErrorTimer = true;
            await Wait( 200 );
            this.InputErrorTimer = false;
            this.InputError = false;

        }

        public Recientes: boolean = false;
        public Primera: boolean = true;
        protected expandir: boolean = true;
        public get Expandir() { return this.expandir; }
        public set Expandir( x: boolean )
        {
            this.expandir = x;
            if ( this.expandir )
            {
                this.Seleccionado = -1;
                this.Items.clear();
                if ( this.Busqueda )
                {
                    this.Buscar();
                }
                //this.Controlador.Vista.BarraIzquierda.Altura.Espacio = '100vh !important';
            } else
            {
                this.Seleccionado = -1;
                this.Busqueda = '';
                this.Items.clear();
                //this.Controlador.Vista.BarraIzquierda.Altura.Espacio = 'var(--toolbar-principal-height) !important';
            }
        }
        public Items: Pedido[] = [];
        public get Pedido()
        {
            if ( this.Items[this.Seleccionado] )
            {
                return this.Items[this.Seleccionado];
            }
        }
        public Seleccionado: number = -1;
        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        async onBusqueda()
        {
            if ( this.Expandir )
            {
                let bb = this.Busqueda;
                await Wait( 600 );
                if ( bb == this.Busqueda )
                {
                    await this.Buscar();
                    this.Seleccionado = -1;

                }
            }
        }

        public async Buscar( forzar?: boolean )
        {
            this.Recientes = false;
            if ( !this.Busqueda && !this.Primera )
            {
                this.Items.clear();
                return;
            } else
            {
                let ff: any = {};

                if ( this.Controlador.EdicionPedido.Modo == "mostrador" )
                    ff.tipo = Pedidos.Tipos.Mostrador.Id;
                else if ( this.Controlador.EdicionPedido.Modo == "normal" )
                    ff.tipo = Pedidos.Tipos.Normal.Id;

                if ( this.Primera )
                {
                    ff.limit = 5;
                    ff.tags = 'para_preparar';
                    this.Primera = false;
                }

                if ( this.Busqueda )
                    ff.q = this.Busqueda;


                this.Estado = 'cargando';
                let e = await Pedido.find( ff );
                if ( !e.Error )
                {
                    if ( ff.tags && ff.tags == 'para_preparar' )
                    {
                        this.Recientes = true;
                    }

                    this.Items = e.Items;
                } else
                {
                    this.Items.clear();
                }

                if ( this.Items.hasRows() )
                    this.Estado = 'ok';
                else
                    this.Estado = 'vacio';
            }
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        async mounted()
        {
            this.Controlador.Vista.BarraIzquierda.Anchura.Espacio = '400px';
            this.Primera = true;
            this.Buscar();
        }

        KeyDown( e: KeyboardEvent )
        {
            if ( ['Escape', 'Enter', 'F3', 'F5', 'PageUp', 'PageDown', 'ArrowDown', 'ArrowUp'].includes( e.key ) )
            {
                e.preventDefault();
            }
        }
        async KeyUp( e: KeyboardEvent )
        {
            console.log( e );

            if ( e.key == 'Escape' )
            {
                if ( this.Expandir )
                {
                    if ( this.Busqueda )
                    {
                        this.Busqueda = '';
                    } else
                    {
                        this.Items.clear();
                        this.Expandir = false;
                        this.ExpandirDetalles = false;
                    }
                }
                else
                {

                    if ( this.Items.hasRows() )
                    {
                        this.Items.clear();
                    } else
                    {
                        this.Busqueda = '';
                    }
                }
            }
            else if ( e.key == 'F3' )
            {
                this.Expandir = !this.Expandir;
            }
            else if ( e.key == 'F5' )
            {
                this.Crear();
            }
            else if ( e.key == 'PageUp' )
            {
                this.SeleccionarLista( 0 );
            }
            else if ( e.key == 'PageDown' )
            {
                this.SeleccionarLista( this.Items.length - 1 );
            }
            else if ( e.key == 'ArrowUp' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Seleccionado - 1 );
            }
            else if ( e.key == 'ArrowDown' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Seleccionado + 1 );
            }
            else if ( e.key == 'ArrowLeft' && e.ctrlKey )
            {
                this.ExpandirDetalles = false;
                //this.Controlador.Vista.BarraIzquierda.Anchura.Espacio = '400px';
            }
            else if ( e.key == 'ArrowRight' && e.ctrlKey )
            {
                if ( this.Pedido && this.Expandir )
                {
                    this.ExpandirDetalles = true;
                }

            }
            else if ( e.key == 'Enter' )
            {
                if ( this.Expandir )
                {
                    if ( this.Pedido )
                    {
                        this.Seleccionar( this.Pedido );
                    }
                }
                else if ( this.Items.hasRows() )
                {
                    if ( this.Pedido )
                    {
                        this.Seleccionar( this.Pedido );
                    } else if ( this.Busqueda && this.Busqueda.borraLetras().length > 1 )
                    {
                        if ( parseInt( this.Busqueda.borraLetras() ) == 0 )
                        {
                            this.onInputError();
                            return;
                        }

                        let item = await Pedido.create( parseInt( this.Busqueda.borraLetras() ) );
                        if ( item )
                        {
                            this.Seleccionar( item );
                        } else
                        {
                            this.onInputError();
                        }
                    }
                } else if ( this.Busqueda && this.Busqueda.borraLetras().length > 1 )
                {
                    if ( parseInt( this.Busqueda.borraLetras() ) == 0 )
                    {
                        this.onInputError();
                        return;
                    }

                    let item = await Pedido.create( parseInt( this.Busqueda.borraLetras() ) );
                    if ( item )
                    {
                        this.Seleccionar( item );
                    } else
                    {
                        this.onInputError();
                    }
                }


            }


        }

        public Crear()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'nuevo';
        }

        public SeleccionarLista( x: number )
        {
            if ( this.Items[x] )
            {
                this.Seleccionado = x;
                if ( this.Expandir )
                {
                    if ( !this.isVisibleLista( this.Seleccionado ) )
                        this.ScrollToItemLista();
                } else
                {
                    if ( !this.isVisibleListaMini( this.Seleccionado ) )
                        this.ScrollToItemListaMini();
                }

            }
        }

        protected ScrollToItemLista()
        {
            let element = document.getElementById( 'barra-izquierda-lista' );
            let element2 = document.getElementById( 'barra-izquierda-lista-item-' + this.Seleccionado );
            this.$vuetify.goTo( element2, {

                container: element,
                offset: 20,
                duration: 0,
            } );
        }

        protected isVisibleLista( item: number )
        {
            let el = JQuery( '#barra-izquierda-lista-item-' + item );
            let lista = JQuery( '#barra-izquierda-lista' );
            let winTop = lista.scrollTop();
            let winBottom = winTop + lista.height();
            let elTop = el.offset().top;
            let elBottom = elTop + el.height();
            return ( ( elBottom <= winBottom ) && ( elTop >= winTop ) );
        }

        protected ScrollToItemListaMini()
        {
            let element = document.getElementById( 'barra-izquierda-lista-mini' );
            let element2 = document.getElementById( 'barra-izquierda-lista-mini-item-' + this.Seleccionado );
            this.$vuetify.goTo( element2, {

                container: element,
                offset: 20,
                duration: 0,
            } );
        }

        protected isVisibleListaMini( item: number )
        {
            let el = JQuery( '#barra-izquierda-lista-mini-item-' + item );
            let lista = JQuery( '#barra-izquierda-lista-mini' );
            let winTop = lista.scrollTop();
            let winBottom = winTop + lista.height();
            let elTop = el.offset().top;
            let elBottom = elTop + el.height();
            return ( ( elBottom <= winBottom ) && ( elTop >= winTop ) );
        }

        async Seleccionar( x: Pedido )
        {
            await this.Controlador.Iniciar( x );
        }

        AbrirMenu()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'menu';
        }
    }
